import React, { ReactNode } from 'react';

import { Headline2 } from './styles';

type Props = {
  children?: ReactNode;
  className?: string;
};

const H2 = ({ children, className }: Props) => <Headline2 className={className}>{children}</Headline2>;

export default H2;
